<script lang="ts">
import type { DirectiveBinding } from "vue";
import { MDCRipple } from "@material/ripple";

export default {
  mounted(el: any, binding: DirectiveBinding) {
    if (binding.value !== true) {
      const ripple = new MDCRipple(el);
      el.rippleHander = ripple;
    }
  },

  beforeUnmount(el: any) {
    if (el.rippleHandler) {
      el.rippleHander.destroy();
    }
  },
};
</script>
